import ExcelJS from "exceljs";
import { saveAs } from 'file-saver';
import DrawExcel from "@/commonFuncion/DrawExcel";

export async function exportExcelTransactionCountAdmin(exportToExcelData,  listDataExportExcel) {

    const fileName = exportToExcelData.nameFile;
    const workbook = new ExcelJS.Workbook();

    const sheetName = "ONEKIDS"

    await addDataList(workbook, sheetName,listDataExportExcel);
    // Dữ liệu truyền vào từ component
    async function addDataList(workbook, sheetName) {
        const titleFile = exportToExcelData.titleFile;
        let  columnHeaders = [
            'STT', 'Ngày', 'Tổng số giao dịch vào trên Sepay', 'Tổng số giao dịch ra trên Sepay',
            'Tổng số giao dịch trên Sepay', 'Tổng số giao dịch vào trên Onekids','Tổng số giao dịch ra trên Onekids', 'Tổng số giao dịch trên Onekids'
        ]
        const companyInfo = exportToExcelData.companyInfo;
        const columnWidths = exportToExcelData.columnWidths;
        let dataList = []
        dataList = await  getDataTable(sheetName,listDataExportExcel)

        const worksheet = workbook.addWorksheet(sheetName);

        await DrawExcel.drawColumnWidths(columnWidths, worksheet);

        await DrawExcel.drawCompanyInfo(companyInfo, worksheet);
        await DrawExcel.drawTitleRowNew(titleFile, worksheet);
        worksheet.addRow([]);
        await DrawExcel.drawTableHeadersStatistics(columnHeaders, worksheet);
        await DrawExcel.drawTableStatistics(dataList, worksheet);
        let otherObject = []
        otherObject = await calculateTotalMoney(listDataExportExcel)
        await DrawExcel.drawTotalDataStatistics(otherObject, worksheet);

    }
    async function getDataTable(sheetName,listDataExportExcel){
        let dataList = []
        for (let i = 0; i < listDataExportExcel.length; i++) {
            dataList.push(listDataExportExcel[i])
        }
        return dataList.map((x, index) => [
            index + 1,
            x.date,
            x.transactionIn,
            x.transactionOut,
            x.transaction,
            x.transactionInOgv,
            x.transactionOutOgv,
            x.transactionOgv,
        ]);
    }

    async  function calculateTotalMoney (listDataExportExcel){
        let a1 = 0;
        let a2 = 0;
        let a3 = 0;
        let a4 = 0;
        let a5 = 0;
        let a6 = 0;
        for (let i = 0; i < listDataExportExcel.length; i++) {
            a1 += listDataExportExcel[i].transactionIn;
            a2 += listDataExportExcel[i].transactionOut;
            a3 += listDataExportExcel[i].transaction;
            a4 += listDataExportExcel[i].transactionInOgv;
            a5 += listDataExportExcel[i].transactionOutOgv;
            a6 += listDataExportExcel[i].transactionOgv;
        }
        return ['Tổng cộng', '', a1 , a2, a3 , a4 , a5 , a6];
    }

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName + '.xlsx');

}

